<template>
  <div class="site-calendar">
    <div class="title">{{ currentMonthTxt }}月大事件</div>
    <div v-if="onlyImportant" class="week-wrapper">
      <div v-for="(item, index) in importantList" :key="index">
        <a v-if="item" :href="item.link" target="_blank">
          <div class="day-wrapper">
            <div class="day">{{ item.date.split("-").at(-1) }}</div>
            <img class="pic" :src="item.icon" :alt="item.name" />
            <div class="name" @mouseenter="onMouseenterName">{{ item.name }}</div>
          </div>
        </a>
        <div v-else class="activity-empty">
          <div class="empty-txt">今日无事，勾栏听曲</div>
        </div>
      </div>
    </div>
    <div v-else class="month-wrapper">
      <div v-for="(item, index) in monthList" :key="index">
        <a v-if="item" :href="item.link" target="_blank">
          <div class="day-wrapper">
            <div class="day">{{ item.date.split("-").at(-1) }}</div>
            <img class="pic" :src="item.icon" :alt="item.name" />
            <div class="name" @mouseenter="onMouseenterName">{{ item.name }}</div>
          </div>
        </a>
        <div v-else class="activity-empty">
          <div class="day">{{ index + 1 < 10 ? "0" + (index + 1) : index + 1 }}</div>
          <div class="empty-txt">今日无事，勾栏听曲</div>
        </div>
      </div>
    </div>
    <div :class="['load-more', onlyImportant ? 'expand' : 'shrink']" @click="onlyImportant = !onlyImportant">
      {{ onlyImportant ? "展开日历" : "收起日历" }}
    </div>
  </div>
</template>
<script>
import tippy from "@/plugins/tippy";
import dayjs from "@/plugins/dayjs";
import { numberToChinese } from "@/plugins/util";

export default {
  name: "SiteCalendar",
  props: {
    calendarList: { type: Array, default: () => [] }
  },
  data() {
    return {
      currentMonthTxt: numberToChinese(dayjs().month() + 1),
      monthList: [],
      importantList: [],
      onlyImportant: true
    };
  },
  watch: {
    calendarList: {
      immediate: true,
      handler(list) {
        this.setMonthList();
        this.setImportantList();
      }
    }
  },
  mounted() {
    console.log("==========全站活动日历数据", JSON.parse(JSON.stringify(this.calendarList)));
  },
  methods: {
    onMouseenterName(event) {
      if (event.target.clientWidth === 110) {
        tippy(event.target, {
          content: event.target.innerText,
          showOnCreate: true,
          onHidden(instance) {
            instance.destroy();
          }
        });
      }
    },
    setMonthList() {
      const list = this.calendarList;
      if (list.length === 0) {
        this.monthList = [];
        return;
      }
      const days = dayjs().daysInMonth();
      const preStr = dayjs().format("YYYY-MM-");
      const array = [];
      let index = 1;
      while (index <= days) {
        const value = list.find(({ date }) => {
          const indexStr = index < 10 ? `0${index}` : `${index}`;
          return date === `${preStr}${indexStr}`;
        });
        array.push(value);
        index++;
      }
      this.monthList = array;
      console.log(array);
    },
    setImportantList() {
      const list = [];
      this.calendarList.forEach(item => {
        if (list.length >= 7) return;
        if (item.important) {
          list.push(item);
        }
      });
      while (list.length < 7) {
        list.push(undefined);
      }
      this.importantList = list;
      console.log(list);
    }
  }
};
</script>
<style lang="less" scoped>
.site-calendar {
  .title {
    color: #171717;
    font-size: 16px;
    font-weight: bold;
    line-height: 30px;
    margin-bottom: 16px;
  }
  .week-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .month-wrapper {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 16px;
  }
  .day-wrapper {
    position: relative;
    width: 166px;
    height: 204px;
    background: url("~@/assets/images/calendar_back.png") center/cover no-repeat;
  }
  .day {
    color: #484848;
    font-size: 15px;
    position: absolute;
    left: 16px;
    top: 10px;
  }
  .pic {
    width: 136px;
    height: 100px;
    position: absolute;
    top: 46px;
    left: 12px;
    border-radius: 4px;
    object-fit: cover;
    object-position: center;
  }
  .name {
    color: #333333;
    font-size: 12px;
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    max-width: 110px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .activity-empty {
    position: relative;
    width: 166px;
    height: 204px;
    background: url("~@/assets/images/calendar_empty.png") no-repeat;
    background-size: 100% 100%;
    .empty-txt {
      color: #d3d3d9;
      font-size: 12px;
      position: absolute;
      bottom: 58px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      max-width: 110px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .load-more {
    margin: 16px auto;
    width: fit-content;
    cursor: pointer;
  }
  .expand::before {
    content: url("~@/assets/images/calendar_more.png");
    transform: scale(0.5) translate(10px, 5px);
    display: inline-block;
  }
  .shrink::before {
    content: url("~@/assets/images/calendar_more.png");
    transform: scale(0.5) translate(10px, 0px) rotate(180deg);
    display: inline-block;
  }
}
</style>
